
import styled from 'styled-components';
import { MENU_HEIGHT } from '../../constants/styles';

export const PageWrapper = styled.section`
    //border: 1px solid orange;
    margin: 10px 15px ${MENU_HEIGHT + 10}px;
`;